import React from "react";
import {Helmet} from "react-helmet";
import {ViviaWisperwind} from "../../constants/meta";

export const A36Meta = () => (
    <Helmet>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | XYZ Sound Sculpture"/>
        <meta name="twitter:description"
              content=". Vieunite provides a dedicated digital canvas to extend XYZ's open chain of sensory translation, visualising Marcos Micozzi and Hef Prentice’s spatial audio architecture as an immersive digital art experience.  "/>
        <meta name="twitter:url" value="https://vieunite.com/artists/xyz-sound-sculpture"/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_xyz_sound_sculpture.jpg"/>

        <meta property="og:url" content="https://vieunite.com/artists/xyz-sound-sculpture"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | XYZ Sound Sculpture"/>
        <meta property="og:description"
              content=" Vieunite provides a dedicated digital canvas to extend XYZ's open chain of sensory translation, visualising Marcos Micozzi and Hef Prentice’s spatial audio architecture as an immersive digital art experience.  "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ xyz_sound_sculpture.jpg"/>


    </Helmet>);